export var Vertical = {
  Top: 'top',
  Bottom: 'bottom'
};